import { render, staticRenderFns } from "./FieldType9Configure.vue?vue&type=template&id=6cb0d34e&scoped=true"
import script from "./FieldType9Configure.vue?vue&type=script&lang=js"
export * from "./FieldType9Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb0d34e",
  null
  
)

export default component.exports